<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="faq-page-header">
    <mat-card-title class="faq-page-title-row">
      <button type="button" class="faq-back-btn" (click)="cancel()">
        <img src="/assets/images/back to list.svg" alt="" />
        Back
      </button>
      <span class="faq-page-title">Frequently Asked Questions</span>
    </mat-card-title>
  </mat-card-header>

  <div class="mat-card-wrapper" style="background-color: #f3f3f3">
    <mat-card-content class="mcd-card-content" style="background-color: #f3f3f3; padding: 24px; margin-bottom: 20px">
      <div style="max-width: 900px; margin: 0 auto">
        <div style="background-color: #ffffff; border-radius: 8px; border: 1px solid #a0a0a04d; overflow: hidden;">

          <!-- Inner Card Header -->
          <div
            style="font-size: 15px; font-weight: 700; color: #4d5258; padding: 18px 24px; border-bottom: 1px solid #a0a0a04d;">
            {{ isEditMode ? 'Edit FAQ' : 'Add New FAQ' }}
          </div>

          <!-- Inner Form Content -->
          <div style="padding: 24px 32px">
            <form (ngSubmit)="submit()" #faqForm="ngForm">

              <!-- Title Field -->
              <div class="title-field-group" style="margin-bottom: 24px;">
                <label style="    font-size: 15px;
    font-weight: 500;
    color: #595A6C; display: flex; align-items: center; margin-bottom: 8px;">
                  Title<span style=" margin-left: 2px;">*</span>
                  <img src="/assets/images/Vector.svg" alt="info" style="width: 15px; height: 15px; margin-left: 6px;"
                    title="Enter topic title" />
                </label>
                <input type="text" name="title" [(ngModel)]="title" placeholder="Enter title" required
                  style="width: 100%; border: 1.5px solid #C1C6CD; border-radius: 6px; padding: 10px 14px; font-size: 14px; color: #34393f; outline: none;" />
              </div>

              <!-- Dynamic Questions Section -->
              <div class="questions-section">
                <div *ngFor="let q of questions; let i = index" style="margin-bottom: 20px;">
                  <label style="    font-size: 15px;
    font-weight: 500;
    color: #595A6C; margin-bottom: 6px; display: block;">
                    Question {{ i + 1 }}
                  </label>

                  <div style="border: 1.5px solid #C1C6CD; border-radius: 8px; overflow: hidden; background: #ffffff;">

                    <!-- Question Title Header Row -->
                    <div
                      style="background-color: #f8fafb; padding: 10px 14px; border-bottom: 1.5px solid #C1C6CD; display: flex; align-items: center; justify-content: space-between;">
                      <input type="text" [name]="'question_' + i" [(ngModel)]="q.question"
                        placeholder="Type question here..." required
                        style="border: none; background: transparent; font-size: 14px; color: #34393f; font-weight: 500; width: 100%; outline: none;" />
                      <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0;">
                        <img src="/assets/images/question-mark 2.svg" alt=""
                          style="width: 14px; height: 14px;" />
                        <button type="button" (click)="removeQuestion(i)"
                          style="background: transparent; border: none; cursor: pointer; padding: 0; display: flex; align-items: center;"
                          title="Clear this question, click again to remove it">
                          <img src="/assets/images/Right Link (2).svg" alt="Remove question"
                            style="width: 20px; height: 20px;" />
                        </button>
                      </div>
                    </div>

                    <!-- Answer Body Row -->
                    <div style="padding: 12px 14px;">
                      <textarea [name]="'answer_' + i" [(ngModel)]="q.answer" placeholder="answer..." rows="3" required
                        style="border: none; width: 100%; font-size: 14px; color: #34393f; line-height: 1.6; resize: vertical; outline: none; min-height: 70px; background: transparent;"></textarea>
                    </div>

                    <!-- Hashtag Footer Row -->
                    <div style="border-top: 1px solid #f3f3f3; padding: 8px 14px; background-color: #ffffff;">
                      <input type="text" [name]="'hashtag_' + i" [(ngModel)]="q.hashtag" placeholder="#Hashtag" style="border: none; width: 100%;     font-size: 12px;
    color: #A2A8B0;
    font-weight: 400; outline: none; background: transparent;" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Add Another Question Button -->
              <div style="margin-bottom: 28px;">
                <button type="button" (click)="addQuestion()" style="background-color: #eef2ff; border: none;     color: #3F51B5D9;
    font-size: 12px;
    font-weight: 600;
    padding: 10px 8px; border-radius: 6px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
                  <span style="font-size: 15px; font-weight: 700; line-height: 1;">+</span> Add Another Question
                </button>
              </div>

              <!-- Footer Buttons -->
              <div
                style="display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid #f3f3f3;">
                <button type="button" (click)="cancel()" style="background-color: #ffffff; border: 1px solid #a0a0a04d; color: #4D5258;
    font-size: 15px;
    font-weight: 500; padding: 8px 24px; border-radius: 6px; cursor: pointer;">
                  Cancel
                </button>
                <button type="submit" [disabled]="!title || !isFormValid()"
                  style="background-color: #ffcd00; border: none; color: #34393f; font-size: 14px; font-weight: 700; padding: 9px 32px; border-radius: 6px; cursor: pointer;">
                  Submit
                </button>
              </div>

            </form>
          </div>

        </div>
      </div>
    </mat-card-content>
  </div>
</mat-card>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>